/**
 * pieTheme — light/dark theme controller for the PIE shell.
 *
 * - Reads/writes a single `localStorage` key ('pie.theme').
 * - Allowed values: 'light' | 'dark'. If unset, we use the system
 *   preference (`prefers-color-scheme: dark`) so first-load matches
 *   the user's OS default without requiring them to toggle.
 * - Toggling adds/removes the `pie-dark` class on the PIE shell
 *   (NOT on <html>) so the theme is scoped to the PIE module — the
 *   broader LIE app keeps its own theme.
 */

const STORAGE_KEY = 'pie.theme';

export function getStoredTheme() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'light' || v === 'dark') return v;
  } catch (_) { /* SSR / privacy mode */ }
  return null;
}

export function getInitialTheme() {
  const stored = getStoredTheme();
  if (stored) return stored;
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return 'light';
}

export function setStoredTheme(theme) {
  try { localStorage.setItem(STORAGE_KEY, theme); } catch (_) { /* ignore */ }
}

/** Apply theme to every existing `.pie-shell` in the DOM. */
export function applyThemeToShells(theme) {
  if (typeof document === 'undefined') return;
  document.querySelectorAll('.pie-shell').forEach((el) => {
    if (theme === 'dark') el.classList.add('pie-dark');
    else el.classList.remove('pie-dark');
  });
}
